module.exports = __webpack_public_path__ + "static/media/cuimeca.9184346e.png";